import { IFilterOptions } from "@interfaces/filters/IFilterOptions";
import { IDataDefinition } from "@reports/models/IReportDefinition";
import { IReportParameters } from "@reports/models/IReportParameters";

export class FilterOptionsService {
    createFilterOptions(reportDefinition: IDataDefinition): IFilterOptions {
        const parameters = reportDefinition.Parameters;

        const options: IFilterOptions = {
            dateFilter: {
                start: parameters.Start,
                end: parameters.End
            }
        };

        if (parameters.VehicleId) {
            options.vehicleFilter = {
                vehicle: parameters.Vehicle || { Id: parameters.VehicleId }
            };
        }

        return options;
    }

    createReportParameters(filterOptions: IFilterOptions): IReportParameters {
        var parameters: IReportParameters = {
            Start: filterOptions.dateFilter.start,
            End: filterOptions.dateFilter.end
        };

        // If start and end time is the same ignore it, this makes backend faster
        if (filterOptions.dateFilter.startTime && filterOptions.dateFilter.endTime
            && filterOptions.dateFilter.startTime != filterOptions.dateFilter.endTime
            && (filterOptions.dateFilter.startTime != "00:00:00" || filterOptions.dateFilter.endTime != "23:59:59")) {
            parameters.TimeFilterStart = filterOptions.dateFilter.startTime;
            parameters.TimeFilterEnd = filterOptions.dateFilter.endTime;
            parameters.TimeFilterType = filterOptions.dateFilter.filterType;
        }

        if (filterOptions.groupFilter && filterOptions.groupFilter.group) {
            parameters.VehicleGroupId = filterOptions.groupFilter.group.Id;
            parameters.DriverGroupId = filterOptions.groupFilter.group.Id;
        }

        if (filterOptions.driverFilter && filterOptions.driverFilter.driver) {
            parameters.DriverId = filterOptions.driverFilter.driver.Id;
        }

        if (filterOptions.vehicleFilter && filterOptions.vehicleFilter.vehicle) {
            parameters.VehicleId = filterOptions.vehicleFilter.vehicle.Id;
        }

        return parameters;
    }
}
